<template>
  <div class="layout-title-container">
    <a-breadcrumb :routes="routes" class="breadcrumb">
      <template slot="itemRender" slot-scope="{ route, params, routes, paths }">
        <span v-if="routes.indexOf(route) === routes.length - 1">
          {{ route.name }}
        </span>
        <router-link v-else :to="`/${paths.join('/')}`">
          {{ route.name }}
        </router-link>
      </template>
    </a-breadcrumb>

    <h2>{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'LayoutTitle',

  components: {},

  props: {},

  created() {},

  mounted() {},

  updated() {},

  watch: {},

  computed: {
    title() {
      return this.$route.name
    },

    routes() {
      if (this.$route.path === '/') {
        return [{ path: '/', name: '首页' }]
      } else {
        return this.$route.meta.breadcrumb
      }
    }
  },

  data() {
    return {}
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
.layout-title-container {
  position: relative;
  box-sizing: border-box;
  margin: 0;
  padding: 16px 32px 0;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  list-style: none;

  .breadcrumb {
    margin-bottom: 12px;
  }
}
</style>
